import { mutatorAction } from "satcheljs";

import { IImportJobEntity } from "../../../sh-models";
import { ImportJobsStore } from "../store/ImportJobsStore";

export const setImportJobs = mutatorAction("setImportJobs", (importJobs: Array<IImportJobEntity>) => {
    ImportJobsStore().jobs.replace(importJobs);
});